import { bindable, computedFrom } from 'aurelia-framework';
import { BindableNumber, getInt } from 'framework/aurelia_tools/binding-types';
import Split from 'split.js';

export class AfSplitCustomElement {
  @bindable direction: 'horizontal' | 'vertical' = 'horizontal';
  @bindable percentFirst: BindableNumber;
  @bindable percentSecond: BindableNumber;
  @bindable minsizeFirst: BindableNumber;
  @bindable minsizeSecond: BindableNumber;
  @bindable snapOffset: BindableNumber;
  public panel1: HTMLDivElement;
  public panel2: HTMLDivElement;
  public refresh: () => void;

  attached() {
    const percentFirst = (this.percentFirst != null ? getInt(this.percentFirst) : null) || (this.percentSecond != null ? 100 - getInt(this.percentSecond) : 50);
    const percentSecond = (this.percentSecond != null ? getInt(this.percentSecond) : null) || (this.percentFirst != null ? 100 - getInt(this.percentFirst) : 50);
    const minsizeFirst = this.minsizeFirst != null ? getInt(this.minsizeFirst) : 0;
    const minsizeSecond = this.minsizeSecond != null ? getInt(this.minsizeSecond) : 0;
    const snapOffset = this.snapOffset != null ? getInt(this.snapOffset) : 40;

    const toggle = split => {
      split.destroy();
      this.direction = this.direction === 'horizontal' ? 'vertical' : 'horizontal';
      this.attached();
    };

    const split = Split([this.panel1, this.panel2], {
      direction: this.direction,
      sizes: [percentFirst, percentSecond],
      minSize: [minsizeFirst, minsizeSecond],
      snapOffset: snapOffset,
      gutter: (index, direction) => {
        const gutter = document.createElement('div');
        gutter.className = 'af-split__gutter';
        gutter.addEventListener('dblclick', () => toggle(split));
        return gutter;
      },
      onDragEnd: (sizes: number[]) => {
        this.percentFirst = Math.round(sizes[0]);
        this.percentSecond = Math.round(sizes[1]);
      }
    });

    this.refresh = () => {
      split.destroy();
      this.attached();
    }
  }

  @computedFrom('direction')
  get templateClass() {
    return `af-split af-split--${this.direction}`;
  }

  @computedFrom('direction')
  get panel1Class() {
    return `af-split__panel af-split__panel--${this.direction === 'horizontal' ? 'left' : 'top'}`;
  }

  @computedFrom('direction')
  get panel2Class() {
    return `af-split__panel af-split__panel--${this.direction === 'horizontal' ? 'right' : 'bottom'}`;
  }
}
